






























import { cloneDeep } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import {
  GroupedBotProperty, BotProperty,
} from '../../../../../../../../../../../BotProperties/components/Properties/types'
import { getNewPropertyIcon, getPropertyTranslation, sortProperties } from '../../../../../../../../../../../BotProperties/utils'
import Icon from '../../../../../../../../../../../Icon/Icon.vue'
import NestedContent from '../../../../../../../../../../../Pi/components/NestedContent.vue'

@Component({
  components: {
    NestedContent,
    Icon
  },
  data() {
    return {
      getNewPropertyIcon,
      getPropertyTranslation
    }
  }
})
export default class UserPropertiesCellProperties extends Vue {
  @Prop() properties!: Array<GroupedBotProperty>

  @Prop() selectedId!: number

  @Emit()
  selectProperty(id: Array<number>): number {
    return id[0]
  }

  get selected() {
    return [ this.selectedId ]
  }

  set selected(value: Array<number>) {
    this.selectProperty(value)
  }

  get preparedProperties(): Array<BotProperty & { children?: Array<BotProperty> }> {
    const setChildren = (properties: Array<BotProperty>): Array<BotProperty & {children?: Array<BotProperty>}> => {
      // children field for treeview in table
        return properties.map(p => ({
          ...p,
          ...p?.properties?.length ? {
            children: setChildren(p?.properties),
          } : {}
        }))
    }

    return setChildren(sortProperties(this.properties))
  }
}
